import { useCallback, useContext } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { BREEZE_TOOLTIP_DELAY } from 'chatspot-core/constants/Delays';
import { SectionContext } from '../../../context/SectionContext';
import { jsx as _jsx } from "react/jsx-runtime";
const LinkActionButton = ({
  inDataTable,
  linkActionButton,
  size = 'xs',
  use = 'tertiary',
  disabled,
  tooltip
}) => {
  const {
    onLinkActionClicked
  } = useContext(SectionContext);
  const onClick = useCallback(() => {
    onLinkActionClicked(linkActionButton, {
      inDataTable
    });
  }, [inDataTable, linkActionButton, onLinkActionClicked]);
  return /*#__PURE__*/_jsx(View, {
    maxInlineSize: "200px",
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: tooltip,
      delay: BREEZE_TOOLTIP_DELAY,
      children: /*#__PURE__*/_jsx(Button, {
        href: linkActionButton.href,
        external: linkActionButton.external,
        disabled: disabled,
        onClick: onClick,
        size: size,
        truncate: true,
        use: use,
        width: "fit-content",
        borderRadius: "full",
        children: linkActionButton.label
      })
    })
  });
};
export default LinkActionButton;